import { useTheme } from 'styled-components';
import { ReactComponent as DocumentIconSvg } from '~assets/icons/document.svg';

import Text from '../Text';
import NotificationBanner from '../NotificationBanner';

import * as styled from './styled';
import { ITransshipmentSendFilePreview, TMode, TColorTokens } from './types';

function TransshipmentSendFilePreview({
  filename,
  message,
  variant,
}: ITransshipmentSendFilePreview) {
  const theme = useTheme();
  const colorMap: Record<TMode, TColorTokens> = {
    FILESELECTED: {
      icon: theme.color.icon.neutral.default,
      filename: 'neutral',
      message: 'neutral',
    },
    SENDING: {
      icon: theme.color.icon.neutral.weak,
      filename: 'neutral-weak',
      message: 'neutral',
    },
    DONESENDING: {
      icon: theme.color.icon.neutral.strong,
      filename: 'neutral-strong',
      message: 'neutral-strong',
    },
    BACKENDERROR: {
      icon: theme.color.icon.neutral.strong,
      filename: 'neutral-strong',
      message: 'neutral-strong',
    },
  };

  return (
    <styled.Wrapper>
      <styled.Upper>
        <DocumentIconSvg style={{ color: colorMap[variant].icon }} />
        <Text variant="h600" color={colorMap[variant].filename}>
          {filename}
        </Text>
      </styled.Upper>

      <styled.Bottom>
        {variant !== 'BACKENDERROR' ? (
          typeof message === 'string' ? (
            <Text variant="sub400" color={colorMap[variant].message}>
              {message}
            </Text>
          ) : (
            message
          )
        ) : (
          <NotificationBanner title={message} variant="error" />
        )}
      </styled.Bottom>
    </styled.Wrapper>
  );
}

export default TransshipmentSendFilePreview;
